import styled, { css } from 'styled-components';
import themeGet from '@styled-system/theme-get';

type PatternBackground = {
  isDisplayed: boolean;
};

const gradientStyle = () => css`
  background-image: linear-gradient(
    -45deg,
    rgba(241, 241, 241, 0.5) 25%,
    transparent 25%,
    transparent 50%,
    rgba(241, 241, 241, 0.5) 50%,
    rgba(241, 241, 241, 0.5) 75%,
    transparent 75%,
    transparent
  );
  background-size: ${themeGet('space.2')} ${themeGet('space.2')};
`;

const WithPatternBackground = styled.div`
  & > * {
    ${({ isDisplayed }: PatternBackground) =>
      isDisplayed ? gradientStyle() : ''}
  }
`;

export { WithPatternBackground };
